<template>
  <!-- <Header/> -->
  <div id="main-wrapper">
     <AppLoader v-if="store.loading" />
    <router-view />
    <Gift v-if="store.isGiftPopup" @close="closeGift()"/>
  </div>
  <!-- <Footer /> -->
</template>

<script>
//import Header from "@/components/shared/header";
//import Footer from "@/components/shared/footer";
import AppLoader from "@/components/shared/AppLoader.vue";
import AccountFeed from "@/store/account-stomp";
import { useMainStore } from "@/store";
import Gift from "@/components/shared/gift.vue"
//import static_vars from '@/staticVars'

export default {
  setup() {
    const store = useMainStore();
    return { store };
  },
  data() {
    return {
        giftComp: false
    };
  },
  components: { AppLoader, Gift },
  methods:{
    closeGift(){
        this.store.$patch({'isGiftPopup' : false})
    }
  },
  created(){
    this.store.callCountryList({},false)
    // if(static_vars.getCookie('zulutoken')){
    //   let json = {};
    //   json['access_token'] = this.static_vars.getCookie('zulutoken')
    //   if(static_vars.getCookie('zulurefreshToken')){
    //     json['refresh_token'] = this.static_vars.getCookie('zulurefreshToken')
    //   }
    //   this.store.$patch({'user' : json})
    // }else{
    //   if(this.store.user.access_token){
    //     static_vars.setCookie('zulutoken',this.store.user.access_token,'100d')
    //     if(this.store.user.refresh_token){
    //        static_vars.setCookie('zulurefreshToken',this.store.user.refresh_token,'100d')
    //     }
    //   }
    // }


    // if (localStorage.getItem("zulutoken") !== null) {
    //    let json = {};
    //    json['access_token'] = localStorage.getItem("zulutoken")
    //    if (localStorage.getItem("zulurefreshToken") !== null) {
    //     json['refresh_token'] = localStorage.getItem("zulurefreshToken")
    //    }
    //     this.store.$patch({'user' : json})
    // }else{
    //    if(this.store.user.access_token){
    //       localStorage.setItem('zulutoken', this.store.user.access_token);
    //       if(this.store.user.refresh_token){
    //           localStorage.setItem('zulurefreshToken', this.store.user.refresh_token);
    //       }
    //    }
    // }


    // if(static_vars.getCookie('zuluUserDetail')){
    //   this.store.$patch({'customerDetail' : JSON.parse(static_vars.getCookie('zuluUserDetail'))})
    // }
    //  if(static_vars.getCookie('zuluCountryList')){
    //   this.store.$patch({'countryList' : JSON.parse(static_vars.getCookie('zuluCountryList'))})
    // }
    if(this.store.user.access_token){
      AccountFeed.getInstance().activate();
      this.store.getUserAccountsList({},false)
      this.store.callCustomerDetail({},false,this)
      // this.store.getQuestioanriesStatus({},false)
    }
  },
};
</script>

